import styled from "styled-components";

import {
  DATA_E2E_KEY,
  DRAWER_FOOTER_HEIGHT,
  IStyledAttributes,
} from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const MenuDrawerFooterStyled = styled.footer.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "menu-drawer-footer-styled",
})`
  border-top: 1px solid ${greyMui._300};
  display: flex;
  align-items: center;
  padding-inline: 24px;
  justify-content: center;
  height: ${DRAWER_FOOTER_HEIGHT}px;
  gap: 20px;
`;
